import * as _ from "lodash";
import * as React from "react";
import * as ReactBootstrap from "react-bootstrap";
import { notificationStorageKey } from "../App";
import Fade = ReactBootstrap.Fade;
import { IAppReducerState } from "../shared/model";

const NotificationMessageNotifier: React.FC<INotificationMessageNotifierProps> = (props) => {

    const { appState, dispatch } = props.state;

    const updateLocalStorage = (messages: INotificationMessage[]) => {
        if (typeof (Storage) !== "undefined") {
            const messageStatuses: INotificationMessageViewedStatus[] =
                (messages || []).map((msg) => ({ id: msg.id, viewed: msg.viewed }));

            localStorage.setItem(notificationStorageKey, JSON.stringify(messageStatuses));
        }
    };

    const getMessagesToUpdate = (): INotificationMessage[] => {
        if (!appState.notificationMessages || appState.notificationMessages.length < 1) {
            return [];
        }
        // create clone of the messages
        // quicker than _.cloneDeep, safe because the messages are serializable anyways
        return JSON.parse(JSON.stringify(appState.notificationMessages));
    };

    const handleDismiss = (id: string) => {
        const updatedMessages = getMessagesToUpdate();
        const message = updatedMessages.find((msg) => msg.id === id);
        if (message) {
            message.viewed = true;
        }

        // message viewed states changed => update local storage
        updateLocalStorage(updatedMessages);
        dispatch({ type: "SET_NOTIFICATION_MESSAGES", notificationMessages: updatedMessages });

    };

    return (
        <div>
            {appState.notificationMessages.map((message, idx) => (
                <NotificationMessageViewer
                    key={message.id}
                    message={message.message}
                    viewed={message.viewed}
                    messageId={message.id}
                    onDismiss={handleDismiss}
                    index={idx}
                />
            ))}
            {(!_.isEmpty(appState.notificationMessages) && appState.notificationMessages.some((s) => s.viewed !== true)) && <hr style={{ marginBottom: "10px", borderTopColor: "lightgrey" }} />}
        </div>
    );
};

const NotificationMessageViewer: React.FC<INotificationMessageViewerProps> = (props) => {
    const handleDismissClick = () => {
        props.onDismiss(props.messageId);
    };

    return (
        <Fade in={!props.viewed} unmountOnExit={true} >
            <div className={"clear"}>
                <div className={"alert alert-warning notification-alert"}>
                    <span className="close" onClick={handleDismissClick} id={`dismiss-notification-${props.index}`}>×</span>
                    <p className="alert-text">{props.message}</p>
                </div>
            </div>
        </Fade>
    );
};

export default NotificationMessageNotifier;

export interface INotificationMessage extends INotificationMessageViewedStatus {
    message: string;
}

export interface INotificationMessageViewedStatus {
    id: string;
    viewed: boolean;
}

export interface INotificationMessageViewerState {
    messages: INotificationMessage[];
}
export interface INotificationMessageViewerProps {
    messageId: string;
    message: string;
    viewed: boolean;
    onDismiss: (id: string) => void;
    index: number;
}

interface INotificationMessageNotifierProps {
    state: IAppReducerState;
}
